import { FC } from 'react';

const NotFound: FC = () => {
    return (
        <p className="pt-20 text text-center text_type_main-large text_color_inactive">
            404 Страница не найдена
        </p>
    );
}

export default NotFound;